
<style>
  .salary-attachment-dialog .salary-attachment-heading {
    margin: 0 0 20px;
    color: #111827;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: -0.02em;
    line-height: 1.3;
  }

  .salary-attachment-dialog mat-form-field { width: 100%; }

  .salary-attachment-dialog .salary-attachment-upload {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 24px;
  }

  .salary-attachment-dialog .salary-attachment-upload-label {
    font-size: 13px;
    font-weight: 600;
    line-height: 1.5;
  }

  .salary-attachment-dialog .salary-attachment-file-actions,
  .salary-attachment-dialog .salary-attachment-actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }

  .salary-attachment-dialog .salary-attachment-actions {
    justify-content: flex-end;
    margin-top: 24px;
  }

  .salary-attachment-dialog button[mat-stroked-button],
  .salary-attachment-dialog button[mat-flat-button] {
    height: 44px;
    min-height: 44px;
    margin: 0;
    padding: 0 18px;
    border-radius: 999px;
    font-size: 14px;
    font-weight: 600;
  }
</style>


<!--<h1 mat-dialog-title *ngIf="!isNewCustomer" style="margin-top: 5px;margin-bottom: 35px;">Redigera kund</h1>-->

  <form class="salary-attachment-dialog" name="form" (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>
  <div class="">
    <div class="row">
      <div class="col-md-12">
        <h2 class="salary-attachment-heading">Utmätning av lön</h2>
              
        <div class="row">          
          <div class="col-12">
            <div class="salary-attachment-upload">
              <div class="salary-attachment-upload-label">Ladda upp PDF-dokument</div>
              <div class="salary-attachment-file-actions">
                <ng-container *ngIf="attachmentOfSalary.Document.Guid == null">
                  <input #salaryDocumentUpload hidden type="file" (change)="fileChange($event,attachmentOfSalary.Document)" accept=".pdf,.doc,.docx,.jpeg,.jpg,.png,.gif">
                  <button type="button" mat-stroked-button (click)="salaryDocumentUpload.click()"><mat-icon aria-hidden="true">upload</mat-icon>Ladda upp dokument</button>
                </ng-container>
                <ng-container *ngIf="attachmentOfSalary.Document.Guid != null">
                  <button type="button" mat-stroked-button (click)="showFile(attachmentOfSalary.Document)"><mat-icon aria-hidden="true">open_in_new</mat-icon>Visa dokument</button>
                  <button type="button" mat-stroked-button color="warn" (click)="deleteFile(attachmentOfSalary.Document)">Radera</button>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-12 px-0">

          <div class="row">
            <div class="col-12">
              <h3>Admin</h3>
            </div>

            <!-- Startdatum -->
            <div class="col-12 col-sm-6">
              <mat-form-field floatLabel="always">
                <mat-label>Startdatum</mat-label>
                <input required matInput [matDatepicker]="pickerStartDate" [ngModel]="attachmentOfSalary.DateStart" (dateChange)="attachmentOfSalary.DateStart = toFormattedDate($event.value)" name="pickerStartDate" id="pickerStartDate">
                <mat-datepicker-toggle matSuffix [for]="pickerStartDate"></mat-datepicker-toggle>
                <mat-datepicker #pickerStartDate></mat-datepicker>
              </mat-form-field>
            </div>

            <!-- Slutdatum -->
            <div class="col-12 col-sm-6">
              <mat-form-field floatLabel="always">
                <mat-label>Slutdatum</mat-label>
                <input matInput [matDatepicker]="pickerEndDate" [ngModel]="attachmentOfSalary.DateEnd" (dateChange)="attachmentOfSalary.DateEnd = toFormattedDate($event.value)" name="pickerEndDate" id="pickerEndDate">
                <mat-datepicker-toggle matSuffix [for]="pickerEndDate"></mat-datepicker-toggle>
                <mat-datepicker #pickerEndDate></mat-datepicker>
              </mat-form-field>
            </div>

            <!-- Reserverat belopp -->
            <div class="col-12 col-sm-6">
              <mat-form-field floatLabel="always">
                <mat-label>Reserverat belopp (att beh&aring;lla)</mat-label>
                <input type="text" matInput [ngModel]="attachmentOfSalary.ReservedAmount" (ngModelChange)="attachmentOfSalary.ReservedAmount = $event" md-maxlength="50" id="amount" name="reservedamount" />
              </mat-form-field>
            </div>

            <!-- Utmätt belopp -->
            <div class="col-12 col-sm-6">
              <mat-form-field floatLabel="always">
                <mat-label>Utm&auml;tt belopp (att betala)</mat-label>
                <input type="number" step="0.01" matInput [ngModel]="attachmentOfSalary.AttachmentAmount" (ngModelChange)="attachmentOfSalary.AttachmentAmount = $event" md-maxlength="50" id="temptax" name="attamount" />
              </mat-form-field>
            </div>

            <div class="col-12 col-sm-6">
              <mat-form-field floatLabel="always">
                <mat-label>Referensnummer</mat-label>
                <input type="text" matInput [ngModel]="attachmentOfSalary.ReferenceNumber" (ngModelChange)="attachmentOfSalary.ReferenceNumber = $event" id="temptax" name="referencenr" />
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="salary-attachment-actions">
          <button type="button" mat-stroked-button (click)="cancel()">Avbryt</button>
          <button type="submit" mat-flat-button [disabled]="!(calculateAddButtonValid() && f.form.valid)" color="accent">Lägg till</button>
        </div>
      </div>
        </div>
    </div>

</form>

